import React from 'react';
import { connect } from 'react-redux';
import ListItem from '../../ListItem/ListItem';
import { SUBTOPIC_ALL } from '../../../../constants';
import './CategoryItemsList.css';

const sortRegExp = /"|„|\(/g;

const CategoryItemsList = ({ visibleData, actualSubtopic, sorting, grid }) => {
  const dataArray = visibleData.filter(item =>
    (actualSubtopic === SUBTOPIC_ALL || item[1].subtopic.indexOf(actualSubtopic) !== -1));

  if (sorting <= 1) {
    // title
    dataArray.sort((a, b) => {
      const at = a[1].title.replace(sortRegExp, '');
      const bt = b[1].title.replace(sortRegExp, '');
      return at.localeCompare(bt) * (sorting === 0 ? 1 : -1);
    });
  } else {
    // date
    dataArray.sort((a, b) => {
      const at = a[1].date;
      const bt = b[1].date;
      let ret = 0;
      if (at < bt) {
        ret = -1;
      } else if (at > bt) {
        ret = 1;
      }
      return ret * (sorting === 2 ? 1 : -1);
    });
  }

  const items = dataArray.map(item => (
    <ListItem
      key={item[0]}
      grid={grid}
      itemData={item}
    />
  ));

  return (
    <div id="category-items-list">
      {items}
    </div>
  );
};

const mapStateToProps = state => ({
  visibleData: state.dataCategory.visibleData,
  actualSubtopic: state.dataCategory.subtopic,
  sorting: state.dataCategory.sorting,
  grid: state.resize.grid,
});

export default connect(mapStateToProps)(CategoryItemsList);



// WEBPACK FOOTER //
// ./src/components/App/CategoryPage/CategoryItemsList/CategoryItemsList.js